<h1 mat-dialog-title>PDF Viewer</h1>
<div mat-dialog-content>
  <embed [src]="pdfSrc" type="application/pdf" width="100%" height="500px">
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
